import React from "react";
import MuiCircularProgress from "@mui/material/CircularProgress";
import MuiButton from "@mui/material/Button";
import MuiTextField from "@mui/material/TextField";
import MuiFormHelperText from "@mui/material/FormHelperText";
import MuiAutocomplete from "@mui/material/Autocomplete";

// Source
import * as HelperSrc from "../../HelperSrc";
import * as ModelHelperSrc from "../../model/HelperSrc";
import ControllerLocalization from "../../controller/Localization";
import ControllerPaymentProfile from "../../controller/custom/PaymentProfile";
import ViewDatepicker from "../../view/Datepicker";
import ViewLoader from "../Loader";

let isRendered = false;

const viewPagePaymentProfile: React.FC = () => {
    // Variable
    const controllerPaymentProfile = new ControllerPaymentProfile(isRendered);
    const controllerLocalization = new ControllerLocalization(isRendered);
    const mode = "pi";

    // Method
    controllerPaymentProfile.initializeHook(mode);
    controllerLocalization.initializeHook();

    // Render
    isRendered = true;

    if (controllerLocalization.getStorageMain && controllerPaymentProfile.getSelectOption && controllerPaymentProfile.getValidationForm) {
        return (
            <div className="view_payment_profile form" data-at_id="view_payment_profile">
                {(() => {
                    const html: JSX.Element[] = [];

                    if (controllerPaymentProfile.getDataMain) {
                        html.push(
                            <div>
                                <div>
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_name"
                                            name="name"
                                            label={controllerLocalization.getStorageMain.name}
                                            defaultValue={controllerPaymentProfile.getDataMain.name || ""}
                                            required={controllerPaymentProfile.getValidationForm.name.required}
                                            onChange={(event) => {
                                                if (controllerPaymentProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerPaymentProfile.getValidationForm.name.regex_pattern,
                                                        controllerPaymentProfile.getValidationForm.name.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiAutocomplete
                                            blurOnSelect
                                            options={(() => {
                                                const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                                for (const optionData of Object.values(controllerPaymentProfile.getSelectOption.client_id)) {
                                                    const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                    optionList.push(optionDataTyped);
                                                }

                                                return optionList;
                                            })()}
                                            getOptionLabel={(option) => option.display_name}
                                            value={(() => {
                                                const currentStr =
                                                    controllerPaymentProfile.getElementClientIdValue === "" && controllerPaymentProfile.getDataMain
                                                        ? controllerPaymentProfile.getDataMain.client_id
                                                        : controllerPaymentProfile.getElementClientIdValue;

                                                const opts = (() => {
                                                    const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];
                                                    for (const optionData of Object.values(controllerPaymentProfile.getSelectOption.client_id)) {
                                                        optionList.push(optionData as ModelHelperSrc.IelementOption);
                                                    }
                                                    return optionList;
                                                })();

                                                const selected = opts.find((o) => String(o.value) === String(currentStr)) || opts[0];
                                                return selected;
                                            })()}
                                            renderOption={(props, option) => {
                                                if (controllerLocalization.getStorageMain) {
                                                    return (
                                                        <li {...props} data-at_id={`select_${option.display_name ? option.display_name : "select"}`}>
                                                            {option.display_name || controllerLocalization.getStorageMain.select}
                                                        </li>
                                                    );
                                                }
                                            }}
                                            isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                            renderInput={(params) => (
                                                <div>
                                                    <MuiTextField
                                                        {...params}
                                                        variant="outlined"
                                                        className="field_value"
                                                        data-at_id="input_client"
                                                        required={
                                                            controllerPaymentProfile.getValidationForm
                                                                ? controllerPaymentProfile.getValidationForm.client_id.required
                                                                : false
                                                        }
                                                        onChange={(event) => HelperSrc.checkRegexSelect(event.target.name, event.target.value)}
                                                        label={
                                                            controllerLocalization.getStorageMain ? controllerLocalization.getStorageMain.client : ""
                                                        }
                                                    />
                                                    <input
                                                        type="hidden"
                                                        className="field_value"
                                                        name="client_id"
                                                        defaultValue={
                                                            controllerPaymentProfile.getElementClientIdValue === "" &&
                                                            controllerPaymentProfile.getDataMain
                                                                ? controllerPaymentProfile.getDataMain.client_id !== undefined
                                                                    ? controllerPaymentProfile.getDataMain.client_id
                                                                    : ""
                                                                : controllerPaymentProfile.getElementClientIdValue
                                                        }
                                                    />
                                                </div>
                                            )}
                                            onChange={(_, option) => {
                                                if (option && controllerPaymentProfile.setElementClientIdValue) {
                                                    controllerPaymentProfile.setElementClientIdValue(option.value as string);
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <ViewDatepicker
                                            id="input_date"
                                            fieldMode="datepicker_yearMonthDay"
                                            variant="outlined"
                                            className="field_value date"
                                            data-at_id="input_date"
                                            name="date"
                                            label={controllerLocalization.getStorageMain.date}
                                            defaultValue={controllerPaymentProfile.getDataMain.date || ""}
                                            required={controllerPaymentProfile.getValidationForm.date.required}
                                            onChange={(event) => {
                                                if (controllerPaymentProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerPaymentProfile.getValidationForm.date.regex_pattern,
                                                        controllerPaymentProfile.getValidationForm.date.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                </div>
                                <div className="bottom">
                                    <div className="button_container">
                                        <MuiButton
                                            className="button_primary"
                                            data-at_id="button_update"
                                            disabled={controllerPaymentProfile.getApiLoadingList.profileChange}
                                            onClick={(event) => {
                                                controllerPaymentProfile.clickChange(event);
                                            }}
                                        >
                                            {(() => {
                                                const html: JSX.Element[] = [];

                                                if (controllerPaymentProfile.getApiLoadingList.profileChange) {
                                                    html.push(<MuiCircularProgress className="icon_progress" />);
                                                } else {
                                                    html.push(<>{controllerLocalization.getStorageMain.update}</>);
                                                }

                                                return html;
                                            })()}
                                        </MuiButton>
                                    </div>
                                </div>
                            </div>
                        );
                    }

                    return html;
                })()}
            </div>
        );
    } else {
        return <ViewLoader />;
    }
};

export default viewPagePaymentProfile;
